function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.811,
    height: 54.955,
    viewBox: "0 0 53.811 54.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 239",
    transform: "translate(-30 -222)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 46",
    width: 53.811,
    height: 54.955,
    rx: 10,
    transform: "translate(30 222)",
    style: {
      fill: "#ffedd8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11047",
    transform: "translate(32.267 224.839)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 406",
    cx: 24.639,
    cy: 24.639,
    r: 24.639,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 407",
    cx: 6.884,
    cy: 6.884,
    r: 6.884,
    transform: "translate(17.703 10.611)",
    style: {
      fill: "#f80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2267",
    d: "M29.5 72.786v.569c0 1.139 2.07 2.07 2.07 2.07s6.82 4.692 13.665 4.692 13.717-4.692 13.717-4.692 2.07-.932 2.07-2.07v-.569A17.652 17.652 0 0 0 45.236 62.9 17.337 17.337 0 0 0 29.5 72.786z",
    transform: "translate(-20.649 -36.76)",
    style: {
      fill: "#f80"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.c34225e328d092b612fc1dbea13bfa68.svg";
export { ForwardRef as ReactComponent };